import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Skills', href: '#skills' },
    { name: 'Experience', href: '#experience' },
    { name: 'Projects', href: '#projects' },
    { name: 'Articles', href: '#articles' },
    { name: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-slate-900/95 backdrop-blur-sm border-b border-blue-500/20'
          : 'bg-slate-900/90 backdrop-blur-sm border-b border-blue-500/10'
      }`}
    >
      <nav className="container mx-auto px-3 sm:px-4 lg:px-6 py-2 sm:py-3">
        <div className="flex items-center justify-between gap-2">
          {/* Logo and Clone Button - Left Side */}
          <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
            <div className="text-base sm:text-lg lg:text-2xl font-bold text-blue-400 whitespace-nowrap">
              Swastik Nanda
            </div>
            
            {/* Clone Chat Button - Always Visible */}
            <a
              href="https://d1ixx6komx5bh3.cloudfront.net/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 sm:gap-1.5 px-2 sm:px-3 lg:px-4 py-1.5 sm:py-2 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white font-semibold rounded-full hover:scale-105 active:scale-95 transition-all duration-300 shadow-lg hover:shadow-2xl animate-pulse-rainbow text-[9px] sm:text-xs lg:text-sm whitespace-nowrap relative overflow-hidden group flex-shrink-0"
            >
              <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 opacity-0 group-hover:opacity-100 group-active:opacity-100 blur-sm transition-opacity duration-300"></span>
              <span className="relative z-10 flex items-center gap-1 sm:gap-1.5">
                <span className="text-xs sm:text-base lg:text-lg animate-bounce">💬</span>
                <span className="hidden lg:inline">Chat with My CLONE</span>
                <span className="hidden sm:inline lg:hidden">My CLONE</span>
                <span className="sm:hidden">CLONE</span>
              </span>
            </a>
          </div>

          {/* Right Side - Navigation and Menu Button */}
          <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
            {/* Desktop Navigation */}
            <div className="hidden md:flex space-x-3 lg:space-x-6 xl:space-x-8">
              {navItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => scrollToSection(item.href)}
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-300 relative group text-xs lg:text-sm xl:text-base whitespace-nowrap"
                >
                  {item.name}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
                </button>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden flex-shrink-0">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="text-gray-300 hover:text-blue-400 transition-colors duration-300 p-2"
              >
                {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-blue-500/20 bg-slate-900/95 backdrop-blur-sm">
            <div className="flex flex-col space-y-3 mt-4">
              {navItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => scrollToSection(item.href)}
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-300 text-left py-2 px-2 rounded-lg hover:bg-slate-800/50"
                >
                  {item.name}
                </button>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;